module.exports = __webpack_public_path__ + "img/tutoring_logo.efc5a354.png";